"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var membersActions = require("@caddigital/sok-reducers/lib/actions/customer/members");
var userSettingsActions = require("@caddigital/sok-reducers/lib/actions/user/userSettings");
var Icon_1 = require("components/Icon");
var MemberList_1 = require("components/MemberList");
var InviteCompanyMembers_1 = require("../../modals/InviteCompanyMembers");
var MoveUserToGroup_1 = require("../../../../ProjectTeamMembersView/Users/Modal/MoveUserToGroup");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var mapStateToProps = function (state) {
    return {
        region: state.customer.region,
        currentUser: state.auth.current.user,
        customerUuid: state.customer.wizard.customerUuid,
        members: state.customer.members,
        companyName: state.customer.wizard.step1.companyName
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (customerUuid) {
        return customerUuid !== null &&
            dispatch(membersActions.UsergroupList.fetchRequest('CUSTOMER_MEMBERS', customerUuid));
    },
    inviteToggleModal: function () {
        return dispatch(membersActions.UsergroupInvite.inviteToggleModal());
    },
    openUserSettingsModal: function (user, customerId, level) {
        customerId !== null &&
            dispatch(userSettingsActions.openUserSettingsModal(user, level !== 'NormalUserGroup' ? 'ADMIN' : 'USER', [
                membersActions.UsergroupList.fetchRequest('CUSTOMER_MEMBERS', customerId)
            ]));
    },
    setGroupsSelected: function (items, selected) {
        return dispatch(membersActions.UsergroupList.setGroupsSelected(items, selected));
    },
    setUsersSelected: function (items, selected) { return dispatch(membersActions.UsergroupList.setUsersSelected(items, selected)); },
    collapseUserRow: function (id, isCollapsed) {
        return dispatch(membersActions.UsergroupList.collapseUserRow(id, isCollapsed));
    },
    setSortingSelector: function (sortBy) {
        dispatch(membersActions.UsergroupList.setSortingSelector(sortBy));
    },
    openMoveUserToGroupModal: function (selectedUsers) {
        return dispatch(membersActions.moveUserToGroup(selectedUsers.map(function (x) { return x.user.id; })));
    },
    closeMoveUserToGroupModal: function () { return dispatch(membersActions.moveUserToGroup([])); },
    saveMoveUsersToGroup: function (mapped) {
        return function (users, group) {
            var groups = mapped.categories.map(function (m) { return m.category; });
            var currentGroupAndUser = [];
            var _loop_1 = function (i) {
                var u = users[i];
                for (var i_1 = 0; i_1 < groups.length; i_1++) {
                    var group_1 = groups[i_1];
                    var member = group_1.members && group_1.members.find(function (m) { return m.uuid === u.uuid; });
                    if (member) {
                        currentGroupAndUser.push({ uuid: u.uuid, oldGroup: group_1.uuid });
                        break;
                    }
                }
            };
            for (var i = 0; i < users.length; i++) {
                _loop_1(i);
            }
            dispatch(membersActions.moveUsersToGroupSaveRequest(currentGroupAndUser, group));
        };
    },
    setFilter: function (filter, value) {
        return dispatch(membersActions.UsergroupList.setColumnFilter(filter, value));
    }
}); };
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('CompanyMemebers'), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('searchString', 'setSearchString', ''), (0, recompose_1.withState)('warningModal', 'setWarningModal', null), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.customerUuid !== null &&
            this.props.fetch(this.props.customerId);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.customerUuid !== prevProps.customerUuid) {
            this.props.fetch(this.props.customerId);
        }
    }
}), recompose_1.pure);
var searchEnhance = (0, recompose_1.compose)((0, recompose_1.withState)('tempSearchString', 'setTempSearchString', null), recompose_1.pure);
var onChangeTimeout = undefined;
var SearchBox = searchEnhance(function (props) { return (React.createElement("div", { className: 'search-container' },
    React.createElement(sok_ui_1.TextInput, { value: props.tempSearchString !== null ? props.tempSearchString : props.value, onChange: function (e) {
            var val = e.target.value;
            props.setTempSearchString(val);
            if (onChangeTimeout) {
                clearTimeout(onChangeTimeout);
            }
            onChangeTimeout = setTimeout(function () {
                props.setSearchString(val);
                props.setTempSearchString(null);
            }, 500);
        }, icon: React.createElement(Icon_1.Icon, { className: 'fa-search' }), iconRight: props.value ? (React.createElement("div", { className: 'search-box-right' },
            React.createElement(Icon_1.Icon, { className: 'fa-times', onClick: function () {
                    props.setSearchString('');
                    props.setTempSearchString(null);
                } }))) : undefined, placeholder: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/users/tabs/CompanyMembers/search/searchByNameOrEmail') }))); });
//#endregion
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'step3-company-members' },
    React.createElement("div", { className: 'buttons' },
        React.createElement(sok_ui_1.Button, { icon: React.createElement(Icon_1.Icon, { key: 'invite-icon', className: 'fa-plus-circle' }), size: 'large', onClick: props.inviteToggleModal, color: 'base-green', className: 'text-left', text: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/users/tabs/CompanyMembers/addMember') }),
        React.createElement(sok_ui_1.Button, { disabled: props.members.selectedUsers.length === 0, icon: React.createElement(Icon_1.Icon, { key: 'import-icon', className: 'far fa-arrows-alt' }), size: 'large', color: 'base-green', className: 'text-left', text: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/users/tabs/CompanyMembers/move'), onClick: function () {
                return props.openMoveUserToGroupModal(props.members.selectedUsers);
            } }),
        React.createElement(SearchBox, { setSearchString: props.setSearchString, value: props.searchString })),
    React.createElement("div", { className: 'title' },
        React.createElement("h2", null,
            React.createElement(Icon_1.Icon, { className: 'fa-crown' }), "".concat(props.companyName, " ").concat((0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/users/tabs/CompanyMembers/members')))),
    React.createElement(MemberList_1.MemberList, { translationKeys: {
            notFound: {
                title: 'userfront/project/teamMembers/placeHolderTitle',
                description: 'userfront/project/teamMembers/placeHolderDescription',
                help: 'userfront/project/teamMembers/placeHolderHelp'
            }
        }, groups: props.members.groups, searchString: props.searchString, isCollapsed: props.members.isCollapsed, selectedUsers: props.members.selectedUsers, selectedGroups: props.members.selectedGroups, status: props.members.status, sortingAndPagination: props.members.sortingAndPagination, permission: props.currentUser.fold(0, function (u) {
            return u.level === 'SuperAdminUserGroup' ? acl.SUPER_ADMIN_GRANT : 0;
        }), filters: props.members.filters, fetch: function () { return props.fetch(props.customerId); }, setUsersSelected: props.setUsersSelected, setGroupsSelected: props.setGroupsSelected, collapseUserRow: props.collapseUserRow, setWarningModal: props.setWarningModal, openUserSettingsModal: function (user) {
            return props.openUserSettingsModal(user, props.customerId, props.currentUser.fold('NormalUserGroup', function (x) { return x.level; }));
        }, setSortingSelector: props.setSortingSelector, setFilter: props.setFilter }),
    React.createElement(InviteCompanyMembers_1.default, { customerId: props.customerId }),
    React.createElement(MoveUserToGroup_1.default, { isOpen: props.members.moveUserModal, status: props.members.moveStatus, groups: props.members.groups, users: props.members.selectedUsers, onSave: props.saveMoveUsersToGroup({ categories: props.members.groups }), onUserRemove: function (user, group) {
            return group && props.setUsersSelected([{ user: user, group: group }], false);
        }, onClose: props.closeMoveUserToGroupModal, moveOrCopy: 'MOVE' }),
    React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.warningModal !== null, close: function () { return props.setWarningModal(null); }, header: props.warningModal
            ? props.warningModal.title
            : (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
            React.createElement(ConfirmDialog_1.Exclamation, null),
            React.createElement("div", null,
                React.createElement("div", { className: 'title please-confirm-text' },
                    React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                React.createElement("div", { className: 'text' }, ((props.warningModal && props.warningModal.content) || []).map(function (x) { return (React.createElement("p", null, x)); })))), footer: React.createElement(React.Fragment, null,
            React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                    if (props.warningModal) {
                        props.warningModal.action();
                        props.setWarningModal(null);
                    }
                } }),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setWarningModal(null); } })) }))); });
